<div id="skip-links">
  <a
    [routerLink]="['./']"
    class="skip-link"
    fragment="main-content"
    queryParamsHandling="preserve"
    >Skip to Main Content</a
  >
</div>
<div class="kh-authentication-layout">
  <main class="kh-authentication-layout__main">
    <aside class="kh-authentication-layout__testimonial">
      <app-logo forceWhite="true" height="33px" />
      <div class="kh-authentication-layout__testimonial-content">
        <div>
          <h1>The Future of Infrastructure Decision&nbsp;Support</h1>
        </div>
        <p class="headline-medium">
          Asset Agent is a web-based asset management and project planning tool
          that visualizes asset inventory and condition data and supports
          project prioritization and budget projections.
        </p>
      </div>
    </aside>
    <div
      class="kh-authentication-layout__content"
      id="main-content"
      tabindex="0"
    >
      <div class="inner-content">
        <ng-content />
      </div>
      <app-copyright />
    </div>
  </main>
</div>
